import { render, staticRenderFns } from "./CLCNewsList.vue?vue&type=template&id=160ea88f"
import script from "./CLCNewsList.vue?vue&type=script&lang=js"
export * from "./CLCNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports